// extracted by mini-css-extract-plugin
export default {"container":"volume_container__17IuQ","icon":"volume_icon__1lvIu"};